import App from 'components/App/App';
import ErrorBoundaryWrapper from 'components/ErrorBoundaryWrapper';
import { SearchProvider } from '../context/SearchContext';
import { SessionProvider } from 'next-auth/react';
import '../styles/globals.css';
// Puck editor styles — vendored from @measured/puck@0.18.2 dist/index.css so the
// import path is stable regardless of which puck version is in server node_modules.
import '../styles/puck.css';
import '../styles/email-puck-embed.css';
// Destack includes its own styles, no external CSS import needed
import { Provider } from 'react-redux';
import { store } from 'redux-store/store';
import PublicLayout from 'layouts/PublicLayout';
import appInsightsClient from "../services/appinsights";
import ActiveStoreProvider from 'context/activeStoreProvider';
import { RolePermissionsProvider } from 'hooks/useRolePermissions';
import AccountAccessProvider from 'context/accountAccessProvider';
import AccountAccessGate from 'organisms/billing/AccountAccessGate';

export default function AfoApp({
  Component,
  pageProps: { session, ...pageProps },
  router
}) {

  if (appInsightsClient) {
    appInsightsClient.trackTrace({ message: "Next.js app started" });
  }

  // Public pages
  const isPublicPage = Component.isPublic || false;

  if (isPublicPage) {
    return (
      <ErrorBoundaryWrapper>
        <SessionProvider session={session}>
          <SearchProvider>
            <Provider store={store}>
              <PublicLayout>
                <Component {...pageProps} />
              </PublicLayout>
            </Provider>
          </SearchProvider>
        </SessionProvider>
      </ErrorBoundaryWrapper>
    );
  }


  if (typeof window === 'undefined') {
    console.log(`${new Date().toISOString()} - Rendering: ${router.pathname}`);
  }

  return (
    <ErrorBoundaryWrapper>
      <SessionProvider session={session}>
        <ActiveStoreProvider>
          <RolePermissionsProvider>
            <SearchProvider>
              <Provider store={store}>
                <AccountAccessProvider>
                  <App Component={Component} pageProps={pageProps} router={router} />
                  {/* Beside the page, not around it: the backdrop covers the
                      app so the merchant can see their store is still there
                      while nothing behind it can be used. */}
                  <AccountAccessGate />
                </AccountAccessProvider>
              </Provider>
            </SearchProvider>
          </RolePermissionsProvider>
        </ActiveStoreProvider>
      </SessionProvider>
    </ErrorBoundaryWrapper>
  );
}
